
















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { localISO } from "@/utils/localDate";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import Service from "@/services/RiwayatPerkawinanRalan";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardStatusPernikahanGadar extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;

  isReadOnly!: () => boolean;

  options = [
    { value: 1, text: "Belum Kawin" },
    { value: 2, text: "Kawin" },
    { value: 3, text: "Cerai Hidup" },
    { value: 4, text: "Cerai Mati" },
    { value: 0, text: "Menolak menjawab (UNK)" }
  ];

  statusKmk: number | null = null;
  recordId: number | null = null;
  prefilled = false;
  sumberTanggal: string | null = null;
  loading = false;
  saving = false;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  mounted() {
    this.load();
  }

  @Watch("register")
  onRegisterChange() {
    this.reset();
    this.load();
  }

  reset() {
    this.statusKmk = null;
    this.recordId = null;
    this.prefilled = false;
    this.sumberTanggal = null;
  }

  async load() {
    if (!this.register) return;
    this.loading = true;
    try {
      const res = await Service.getByRegister(this.register);
      const rec = res.data?.data;
      if (rec) {
        this.recordId = rec.id;
        this.statusKmk = rec.status_kmk;
        this.prefilled = false;
        return;
      }
      if (!this.rm) return;
      const last = await Service.latestByPasien(this.rm);
      const prev = last.data?.data;
      if (prev && prev.status_kmk !== null && prev.status_kmk !== undefined) {
        this.statusKmk = prev.status_kmk;
        this.prefilled = true;
        this.sumberTanggal = prev.tanggal;
      }
    } finally {
      this.loading = false;
    }
  }

  async save() {
    if (this.readOnly || this.statusKmk === null) return;
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        unit_id: userModule.user.unit_id,
        status_kmk: this.statusKmk,
        examined_at: localISO()
          .slice(0, 19)
          .replace("T", " ")
      };
      if (this.recordId) {
        await Service.update(this.recordId, payload);
      } else {
        const res = await Service.create(payload);
        this.recordId = res.data?.data?.id ?? null;
      }
      this.prefilled = false;
      appModule.sendSuccessNotice("Status pernikahan tersimpan.");
    } finally {
      this.saving = false;
    }
  }
}
